// ── The RGS providers ──
//
// Named imports, one per provider this game ships. Settings.APP.RGS_PROVIDER
// picks one; PixUpPlay and Redstone exist in this working copy but are not
// part of the game that is built.
//
// This used to be a `require.context` sweep of ./ for every provider's RGS.js.
// It had to go because `require.context` is a WEBPACK api: under Jest this
// module threw on import and took the suites that reach a provider down with
// it. Naming each provider also makes the build fail if its folder is missing.
import Dmon from "./Dmon/RGS";
import PopiPlay from "./PopiPlay/RGS";

// Keyed by FOLDER NAME, which is what Settings.APP.RGS_PROVIDER holds.
const providers = {
  Dmon,
  PopiPlay,
};

export default providers;
